import React from "react";
import Footer from "../Components/Footer";
import CTASection from "../Components/CTASection";
import ScrollReveal from "../Components/ScrollReveal";
import { Link } from "react-router-dom";
import Image3 from "../Images/image 3.png";
import "../Styles/AboutPage.css";

function AboutPage() {
  return (
    <div className="about-page">
      <section className="inner-hero">
        <div className="inner-hero-bg">
          <img src={Image3} alt="" className="inner-hero-img" />
        </div>
        <div className="inner-hero-overlay"></div>
        <div className="inner-hero-content">
          <span className="section-label">ABOUT US</span>
          <h1>Our Story & Mission</h1>
          <p>15+ years of quality craftsmanship and trusted service</p>
          <div className="inner-hero-breadcrumb">
            <Link to="/">Home</Link> <span>/</span> About Us
          </div>
        </div>
      </section>

      <ScrollReveal>
        <section className="about-story">
          <div className="about-story-inner">
            <div className="about-story-text">
              <span className="section-label">OUR STORY</span>
              <h2>Building Excellence Since 2009</h2>
              <p>For over 15 years, Qualified Stucco has been the trusted name in stucco and drywall services. We started with a simple mission: deliver top-quality workmanship that homeowners and businesses can rely on.</p>
              <p>When it comes to exterior finishes, stucco is a timeless and durable option. We understand the importance of providing services that not only enhance aesthetic appeal but also protect your property from the elements.</p>
            </div>
            <div className="about-story-image">
              <img src={Image3} alt="Our team at work" />
              <div className="about-story-badge">
                <strong>15+</strong>
                <span>Years</span>
              </div>
            </div>
          </div>
        </section>
      </ScrollReveal>

      <ScrollReveal>
        <section className="about-values">
          <div className="about-values-inner">
            <span className="section-label">OUR VALUES</span>
            <h2>What Drives Us</h2>
            <div className="values-grid">
              <div className="value-card"><div className="value-number">01</div><h3>Quality First</h3><p>We never cut corners. Premium materials and expert techniques ensure results that last for decades.</p></div>
              <div className="value-card"><div className="value-number">02</div><h3>Customer Focus</h3><p>Every project starts with understanding your vision. We listen, plan, and deliver exactly what you need.</p></div>
              <div className="value-card"><div className="value-number">03</div><h3>Integrity</h3><p>Honest pricing, transparent timelines, and clear communication throughout every project.</p></div>
              <div className="value-card"><div className="value-number">04</div><h3>Excellence</h3><p>We continuously improve our skills and stay current with industry best practices and innovations.</p></div>
            </div>
          </div>
        </section>
      </ScrollReveal>

      <ScrollReveal>
        <section className="about-stats">
          <div className="about-stats-inner">
            <div className="stat-box"><span className="stat-number">15+</span><span className="stat-label">Years Experience</span></div>
            <div className="stat-box"><span className="stat-number">500+</span><span className="stat-label">Projects Completed</span></div>
            <div className="stat-box"><span className="stat-number">100%</span><span className="stat-label">Satisfaction Rate</span></div>
            <div className="stat-box"><span className="stat-number">50+</span><span className="stat-label">5-Star Reviews</span></div>
          </div>
        </section>
      </ScrollReveal>

      <CTASection />
      <Footer />
    </div>
  );
}

export default AboutPage;
